// Third Party Component
import axiosServices from "@pma/utils/axios"
import axiosFinancialServices from "@pma/utils/axiosFinancial"

// Routes
import {
  ADD_CUSTOM_COLUMNS_ENDPOINT,
  CREATE_MULTIPLE_TASK_CLONE,
  CREATE_TASK_CLONE,
  CREATE_TASK_ENDPOINT,
  DELETE_MULTIPLE_TASK,
  DICTIONARY_RESOURCES_ADD_ENDPOINT,
  DICTIONARY_RESOURCES_EDIT_ENDPOINT,
  EDIT_TASK_ENDPOINT,
  EDIT_TASK_GROUP,
  GET_CONTRACTOR_COMPANY_LIST,
  GET_DICTIONARY_RESOURCES_ENDPOINT,
  GET_FILTERS_BY_PROJECT,
  GET_KANBAN_STATUS_WISE_TASKS,
  GET_KANBAN_TASKS_ALL,
  GET_STATISTICS_TASKS_CHART_ENDPOINT,
  GET_SUB_TASKS,
  GET_TASK_GROUPS,
  GET_WEATHER,
  GET_WORK_DIARY_BY_PROJECT,
  GET_WORK_DIARY_STATUS,
  LOGS_BY_TASK_ID_ENDPOINT,
  MOVE_TASK_TO_ANOTHER_PROJECT_ENDPOINT,
  DELETE_NOTE_ENDPOINT,
  LIKE_NOTE_ENDPOINT,
  NOTES_ADD_ENDPOINT,
  NOTES_BY_TASK_ID_ENDPOINT,
  PIN_TASK_ENDPOINT,
  UNLIKE_NOTE_ENDPOINT,
  UPDATE_NOTE_ENDPOINT,
  TASK_BY_CURRENT_USER_ENDPOINT,
  TASK_DELETE_ENDPOINT,
  TASK_GROUP_ADD,
  TASK_GROUP_CLONE,
  TASK_GROUP_DELETE,
  TASK_MOVE_TO_GROUP,
  WORK_DIARY_ADD_ENDPOINT,
  WORK_DIARY_DELETE_ENDPOINT,
  WORK_DIARY_EDIT_ENDPOINT,
  WORK_DIARY_GET_BY_ID,
  WORK_DIARY_RESOURCES_ADD_ENDPOINT,
  WORK_DIARY_RESOURCES_DELETE_ENDPOINT,
  WORK_DIARY_RESOURCES_EDIT_ENDPOINT,
  WORK_DIARY_GET_NOTE_BY_ID,
  WORK_DIARY_FILES_ADD_ENDPOINT,
  WORK_DIARY_CLONE_ENDPOINT,
  CONTRACTOR_APPROVAL_ENDPOINT,
  SUPERVISOR_APPROVAL_ENDPOINT,
  TASK_SESSION_GET_ACTIVE,
  PROJECTS_WISE_TASK_LIST,
  TASKS_PROJECT_WISE,
} from "@pma/utils/api-routes"

export const getOrganizationTasksService = async (payload: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(TASK_BY_CURRENT_USER_ENDPOINT, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const pinnedTaskService = async (id: number) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(`${PIN_TASK_ENDPOINT}/${id}`, { task_id: id })
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const deleteTaskService = async (id: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .delete(`${TASK_DELETE_ENDPOINT}/${id}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const getGroupWiseTaskListService = async (payload: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(GET_TASK_GROUPS, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const getSubTaskListService = async (payload: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(GET_SUB_TASKS, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const getNotesListService = async (taskId: number) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .get(`${NOTES_BY_TASK_ID_ENDPOINT}${taskId}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const editTaskService = async (payload: any) => {
  const response: any = await new Promise((resolve, reject) => {
    axiosServices
      .post(EDIT_TASK_ENDPOINT, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })

  return response.data
}

export const getTaskActivityListService = async (id: number, params: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .get(`${LOGS_BY_TASK_ID_ENDPOINT}/${id}`, { params })
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const createNewTaskService = async (payload: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(CREATE_TASK_ENDPOINT, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const createTaskGroupService = async (payload: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(TASK_GROUP_ADD, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const deleteTaskGroupService = async (groupId: number) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .delete(`${TASK_GROUP_DELETE}${groupId}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const updateTaskGroupService = async (payload: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(EDIT_TASK_GROUP, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const taskGroupCloneService = async (payload: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(TASK_GROUP_CLONE, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const createTaskCloneService = async (payload: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(CREATE_TASK_CLONE, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const deleteMultipleTaskService = async (data: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .delete(DELETE_MULTIPLE_TASK, { data: data })
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const getKanbanTaskListService = async (payload: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(GET_KANBAN_TASKS_ALL, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const getKanbanStatusWiseTaskListService = async (payload: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(GET_KANBAN_STATUS_WISE_TASKS, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const createMultipleTaskCloneService = async (payload: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(CREATE_MULTIPLE_TASK_CLONE, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const insertNoteService = async (payload: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(NOTES_ADD_ENDPOINT, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

// ======================== Status CRUD ========================
export const moveTaskToProjectService = async (payload: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(MOVE_TASK_TO_ANOTHER_PROJECT_ENDPOINT, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
}

export const getStatisticsTasksChartService = async (params: any) => {
  const response = await axiosServices.get(GET_STATISTICS_TASKS_CHART_ENDPOINT, { params })
  return response.data
}

export const getWorkDiaryFiltersService = async (projectId: any) => {
  const response = await axiosServices.get(GET_FILTERS_BY_PROJECT, {
    params: { project_id: projectId },
  })
  return response.data
}

export const moveTaskToGroupService = async (payload: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(TASK_MOVE_TO_GROUP, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
}

export const getWorkDiaryListService = async (payload: any) => {
  const response = await axiosServices.post(GET_WORK_DIARY_BY_PROJECT, payload)
  return response.data
}

export const getWorkDiaryStatusListService = async (params: any) => {
  const response = await axiosServices.get(GET_WORK_DIARY_STATUS, { params })
  return response.data
}

export const getContractorCompanyListService = async (params: any) => {
  const response = await axiosFinancialServices.get(GET_CONTRACTOR_COMPANY_LIST, { params })
  return response.data
}

export const getWorkWeatherListService = async (params: any) => {
  const response = await axiosServices.get(GET_WEATHER, { params })
  return response.data
}

export const getWorkDiaryResourcesListService = async (params: any) => {
  const response = await axiosServices.get(GET_DICTIONARY_RESOURCES_ENDPOINT, { params })
  return response.data
}

export const likeNoteService = async (noteId: number) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(LIKE_NOTE_ENDPOINT, { note_id: noteId })
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const unlikeNoteService = async (noteId: number) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(UNLIKE_NOTE_ENDPOINT, { note_id: noteId })
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const updateNoteService = async (payload: any) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .post(UPDATE_NOTE_ENDPOINT, payload)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const deleteNoteService = async (noteId: number) => {
  const response = await new Promise<any>((resolve, reject) => {
    axiosServices
      .delete(`${DELETE_NOTE_ENDPOINT}/${noteId}`)
      .then((response) => resolve(response))
      .catch((error) => reject(error))
  })
  return response.data
}

export const addTaskTableColumnService = async (payload: any) => {
  const response = await axiosServices.post(ADD_CUSTOM_COLUMNS_ENDPOINT, payload)
  return response.data
}

export const createWorkDiaryService = async (payload: any) => {
  const response = await axiosServices.post(WORK_DIARY_ADD_ENDPOINT, payload)
  return response.data
}

export const editWorkDiaryService = async (payload: any) => {
  const response = await axiosServices.post(WORK_DIARY_EDIT_ENDPOINT, payload)
  return response.data
}

export const createWorkDiaryResourceService = async (payload: any) => {
  const response = await axiosServices.post(WORK_DIARY_RESOURCES_ADD_ENDPOINT, payload)
  return response.data
}

export const updateWorkDiaryResourceService = async (payload: any) => {
  const response = await axiosServices.post(WORK_DIARY_RESOURCES_EDIT_ENDPOINT, payload)
  return response.data
}

export const deleteWorkDiaryService = async (diaryId: number) => {
  const response = await axiosServices.delete(`${WORK_DIARY_DELETE_ENDPOINT}/${diaryId}`)
  return response.data
}

export const cloneWorkDiaryService = async (payload: { diary_id: number; date: string }) => {
  const response = await axiosServices.post(WORK_DIARY_CLONE_ENDPOINT, payload)
  return response.data
}

export const deleteWorkDiaryResourceService = async (diaryResourceId: number) => {
  const response = await axiosServices.delete(
    `${WORK_DIARY_RESOURCES_DELETE_ENDPOINT}/${diaryResourceId}`,
  )
  return response.data
}

export const createDictionaryResourceService = async (payload: any) => {
  const response = await axiosServices.post(DICTIONARY_RESOURCES_ADD_ENDPOINT, payload)
  return response.data
}

export const editDictionaryResourceService = async (payload: any) => {
  const response = await axiosServices.post(DICTIONARY_RESOURCES_EDIT_ENDPOINT, payload)
  return response.data
}

export const getWorkDiaryByIdService = async (diaryId: number) => {
  const response = await axiosServices.get(`${WORK_DIARY_GET_BY_ID}${diaryId}`)
  return response.data
}

export const getWorkDiaryNotesService = async (diaryId: number) => {
  const response = await axiosServices.get(`${WORK_DIARY_GET_NOTE_BY_ID}/${diaryId}`)
  return response.data
}

export const addWorkDiaryNoteService = async (payload: any) => {
  const response = await axiosServices.post(NOTES_ADD_ENDPOINT, payload)
  return response.data
}

export const addWorkDiaryFilesService = async (payload: any) => {
  const response = await axiosServices.post(WORK_DIARY_FILES_ADD_ENDPOINT, payload)
  return response.data
}

export const setContractorApprovalService = async (payload: any) => {
  const response = await axiosServices.post(CONTRACTOR_APPROVAL_ENDPOINT, payload)
  return response.data
}

export const setSupervisorApprovalService = async (payload: any) => {
  const response = await axiosServices.post(SUPERVISOR_APPROVAL_ENDPOINT, payload)
  return response.data
}

export const getActiveTaskSessionsService = async (params: any) => {
  const response = await axiosServices.get(TASK_SESSION_GET_ACTIVE, { params})
  return response.data
}

export const getProjectWiseTaskListService = async (payload: any) => {
  const response = await axiosServices.post(PROJECTS_WISE_TASK_LIST, payload)
  return response.data
}

export const getTasksProjectWiseService = async (payload: any) => {
  const response = await axiosServices.post(TASKS_PROJECT_WISE, payload)
  return response.data
}